import React from 'react';

interface InstitutionMembersSkeletonProps {
  rows?: number;
}

const DEFAULT_ROWS = 3;

const Bone = ({ className }: { className: string }) => <div className={`skeleton ${className}`} />;

/** Mirrors `InstitutionMembersSection`: a role pill, then rows of name, address and seen dates. */
const InstitutionMembersSkeleton: React.FC<InstitutionMembersSkeletonProps> = ({ rows = DEFAULT_ROWS }) => (
  <div>
    <div className="flex items-center gap-2 mb-2">
      <Bone className="h-5 w-40 rounded-full" />
      <Bone className="h-3 w-4" />
    </div>
    <ul className="divide-y divide-border">
      {Array.from({ length: rows }).map((_, i) => (
        <li key={i} className="flex items-start justify-between gap-3 py-2.5">
          <div className="space-y-1.5">
            <Bone className="h-4 w-40" />
            <Bone className="h-3 w-52" />
            <Bone className="h-2.5 w-64" />
          </div>
          <Bone className="h-2 w-2 rounded-full mt-1" />
        </li>
      ))}
    </ul>
  </div>
);

export default InstitutionMembersSkeleton;
